var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRound3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8474,
    cy: 14.5896,
    r: 14,
    fill: "#0DD3A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96912 16.3396L10.4691 18.8396M13.9691 14.8396L16.4691 12.3396M11.9691 16.3396L14.4691 18.8396L20.4691 12.3396",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound3);
export default __webpack_public_path__ + "static/media/check-round-3.a0dbde46323053b02d47e369f8b73ea9.svg";
export { ForwardRef as ReactComponent };